import React from 'react';
import PropTypes from 'prop-types';
import { currency } from 'App/config';
var CartMinDeliveryInfo = function (props) {
    var _a = props.divClassName, divClassName = _a === void 0 ? '' : _a, missingCart = props.missingCart, minCartAmount = props.minCartAmount;
    var text = "(brakuje ".concat(missingCart, " ").concat(currency, ")");
    return React.createElement("div", { className: "text-muted mb-2" },
        React.createElement("span", null,
            "Dostawa mo\u017Cliwa od ",
            minCartAmount,
            " ",
            currency),
        React.createElement("div", { className: divClassName }, text));
};
CartMinDeliveryInfo.propTypes = {
    minCartAmount: PropTypes.number,
    missingCart: PropTypes.number,
    divClassName: PropTypes.string,
};
export default CartMinDeliveryInfo;
